 // Import the functions you need from the SDKs you need
 import { initializeApp } from "firebase/app";

 import { getAuth } from 'firebase/auth';
 import { getFirestore, doc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';

 // TODO: Add SDKs for Firebase products that you want to use
 // https://firebase.google.com/docs/web/setup#available-libraries

 // Your web app's Firebase configuration
 const firebaseConfig = {
     apiKey: "AIzaSyB4CL6vETwax7tDUjKHDOI9NgojbkFuvxQ",
     authDomain: "stream-queuer.firebaseapp.com",
     projectId: "stream-queuer",
     storageBucket: "stream-queuer.appspot.com",
     messagingSenderId: "740975589870",
     appId: "1:740975589870:web:9a58e81718dc58844db6ff"
 };

 // Initialize Firebase variables
 const app = initializeApp(firebaseConfig);
 export const auth = getAuth(app);
 export const firestore = getFirestore(app);

 // Firebase Types
 export type FirebaseUserType = typeof auth.currentUser;

